






































































































import Vue from "vue";
import { ref, watch } from "@vue/composition-api";
export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hide_checkbox: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    multi: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "1.2rem",
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
      required: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    done: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isFoucs = ref(false);
    const local_value = ref(Boolean(props.value));

    watch(
      () => props.value,
      (next) => {
        if (next !== local_value.value) {
          local_value.value = Boolean(next);
        }
      }
    );

    const toggle = () => {
      if (props.hide_checkbox || props.disable || props.readonly) return;
      const next_value = !local_value.value;
      local_value.value = next_value;
      emit("input", next_value);
    };
    return {
      isFoucs,
      local_value,
      toggle,
    };
  },
});
